module.exports = __webpack_public_path__ + "static/media/dois_vizinhos.40afda2b.jpg";